import React, { useState, useEffect } from 'react'

import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@material-ui/core";

import Autocomplete from '@material-ui/lab/Autocomplete';

import {Loading} from '../../../components/Loading/Loading'

import { gql, useApolloClient } from '@apollo/client';
import { useDispatch } from 'react-redux';

import { AddBPMApplicationMessages } from '../../../redux/reducers/BPMReducer';
import BPMDialog from '../../../components/BPMTable/TableComponents/Dialogs/BPMDialog'

const HOLD = gql`
    mutation(
        $id: String!, 
        $onHoldReason: String!,
    ){
        bayphoneHold(
            id:$id, 
            onHoldReason: $onHoldReason,
        ) {
            bayphone {
                id
            }
        }
    }
`;

const ON_HOLD_REASONS = gql`
    query {
        allBayphoneOnHoldReasons {
            id
            name
        }
    }
`;

const BayphoneHoldDialog = props => {
    const [ isLoading, setLoading ] = useState(false);
    const [ onHoldReason, setOnHoldReason ] = useState(null);

    const { open, handleClose, selectedRows, t } = props;

    const dispatch = useDispatch()
    const client = useApolloClient()

    useEffect(() => {
        return () => {
            setLoading(false);
            setOnHoldReason(null);
        };
    }, []);

    const onClickProcess = () => {
        setLoading(true)

        client.mutate({
            mutation: HOLD,
            variables: {
                id: selectedRows[0].id,
                onHoldReason : onHoldReason.value,
            },
        })
        .then(result => {
            const success = result.data;
            
            if (success) {
                handleQueryExecuted(true, t("State change successfully executed"));
            } else {;
                handleQueryExecuted(false, t('An error occurred while changing the state of the Bayphone'));
            }
        })
        .catch(error => {
            handleQueryExecuted(false, JSON.stringify(error))
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const createApplicationMessage = (text, variant) => {
        dispatch(AddBPMApplicationMessages({
            text: text, 
            duration: 8000,
            variant: variant,
        }))
    }

    const handleQueryExecuted  = (success, message) => {
        createApplicationMessage(message, success ? 'success' : 'error');
        setLoading(false);
        onCloseDialog();
    }

    const onCloseDialog = () => {
        setOnHoldReason(null);
        handleClose();
    }

    const submitable = () => {
        return (onHoldReason) && (isLoading === false)
    }

    return (
        <Loading query={ON_HOLD_REASONS} showLoading={false}>
            {(data) => {
                return (
                    <BPMDialog 
                    open={open} 
                    onClose={onCloseDialog}
                    maxWidth='md'
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                    >
                        <DialogTitle id='alert-dialog-title'>
                            <span onClick={(event, reason) => onCloseDialog(event, reason)} style={{fontSize: '1.5em',  cursor: 'pointer', position: 'absolute', right: '5px', top: '-5px'}}>&times;</span>
                            {t('bayphone:Bayphone')}
                        </DialogTitle>
                        <DialogContent>
                            <Autocomplete
                                options={data.allBayphoneOnHoldReasons.map(item => ({label: item.name, value: item.id}))}
                                getOptionLabel={(option) => option.label || ''}
                                getOptionSelected={(option, value) => option.value === value.value}
                                onChange={(event, newValue) => { setOnHoldReason(newValue) }}
                                value={onHoldReason}
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    label={t('bayphone:Hold reason')}
                                    variant='outlined'
                                    style={{ marginBottom: 15 }}
                                    />
                                )}
                            />
                        </DialogContent>
                        <DialogActions style={{ justifyContent: 'space-between' }}>
                            <div>
                                <Button 
                                    style={{ marginRight: 20 }}
                                    onClick={onCloseDialog} 
                                    variant='contained'
                                    disabled={isLoading}
                                >
                                    {t('bayphone:Cancel')}
                                </Button>
                                <Button
                                    onClick={onClickProcess}
                                    variant='contained'
                                    color='primary'
                                    disabled={!submitable()}
                                >
                                    {t('bayphone:Hold')}
                                </Button>
                            </div>
                        </DialogActions>
                    </BPMDialog>
                )
            }}
        </Loading>
    )
};

export default BayphoneHoldDialog;
